import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import graphqlHelpersDSPIsActionEnabledForContentQuery, {
	type graphqlHelpersDSPIsActionEnabledForContentQuery$data,
	type graphqlHelpersDSPIsActionEnabledForContentQuery$variables,
} from './__generated__/graphqlHelpersDSPIsActionEnabledForContentQuery.graphql';

export const preloadIsAttachmentDownloadEnabled = async (contentId: string, spaceKey: string) => {
	const response = await query<
		graphqlHelpersDSPIsActionEnabledForContentQuery$data,
		graphqlHelpersDSPIsActionEnabledForContentQuery$variables
	>({
		query: graphqlHelpersDSPIsActionEnabledForContentQuery,
		variables: {
			action: 'PAGE_EXPORT',
			contentId,
			contentStatus: 'CURRENT',
			contentVersion: 1,
			spaceKey,
		},
	});

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const { mediaConfigEnforceDSPRecorder } = await import(
			/* webpackChunkName: "loadable-confluencessr-utilities-objectrecorder" */ '@confluence/ssr-utilities/entry-points/ObjectRecorder.ts'
		);
		const isAttachmentDownloadAllowed =
			response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed || false;
		// When attachment download is not allowed, enforce the data security policy
		mediaConfigEnforceDSPRecorder.set(!isAttachmentDownloadAllowed);
	}

	return response;
};
